import { useQuery } from "@apollo/client/react"
import IconButton from "@mui/material/IconButton"
import { ChevronLeft, ChevronRight } from "lucide-mui"
import React from "react"

import ACTIVITIES from "@/components/activities"
import ActivitySkeleton from "@/components/activities/skeleton"
import { GetReservationActivitiesDocument } from "@/graphql/graphql"
import { useCursorPagination } from "@/shared/hooks"

const ActivitiesTab = ({ venue, reservation }) => {
  const { cursor, createNavigationFunctions } = useCursorPagination({ perPage: 10 })

  const { data, loading, error } = useQuery(GetReservationActivitiesDocument, {
    variables: {
      slug: venue.slug,
      reservationId: reservation.id,
      ...cursor,
    },
  })

  const pageInfo = data?.reservation?.activities?.pageInfo
  const { hasPreviousPage, hasNextPage, previousPage, nextPage } = createNavigationFunctions(pageInfo)

  if (!data && loading) {
    return (
      <div className="flex flex-col gap-4 p-2">
        <ActivitySkeleton />
      </div>
    )
  }

  if (error) return <div>Error: {error.message}</div>

  const activities = data?.reservation?.activities?.nodes || []

  const renderActivity = (activity) => {
    const Component = ACTIVITIES[activity.key]

    if (Component) {
      return (
        <Component
          key={activity.id}
          venue={venue}
          reservation={reservation}
          activity={activity}
          className="border-0 border-solid border-b border-b-gray-100 px-6"
        />
      )
    }

    return <div key={activity.id}>Unknown activity: {activity.key}</div>
  }

  return (
    <div className="flex flex-col" data-testid="panel-reservations-edit-form-activities">
      <div className="flex flex-col">{activities.map(renderActivity)}</div>

      <div className="flex justify-between w-full px-5 py-2">
        {hasPreviousPage ? (
          <IconButton onClick={previousPage}>
            <ChevronLeft />
          </IconButton>
        ) : null}
        {hasNextPage ? (
          <IconButton onClick={nextPage} className="ml-auto">
            <ChevronRight />
          </IconButton>
        ) : null}
      </div>
    </div>
  )
}

export default ActivitiesTab
